const HTML_CONFIGURATION_OPTIONS_DEFAULT_SELECTED_VALUES = Object.freeze({
  feature: 'PDF',
  property: 'INCLUDE',
  type: 'CLASS',
});

export { HTML_CONFIGURATION_OPTIONS_DEFAULT_SELECTED_VALUES };
